const id = 'optimisticBalances';
export default id;
